import React from "react";
import {DeliveryAddressInput} from "../DeliveryAddressInput.jsx";
import {deliveryAddressOptions} from "../consts.js";
import {GoogleMapSubAreaApiKeys} from "../../../../../consts.js";

export const happyHoursSegmentedOptions = () => {
    return [
        {
            key: deliveryAddressOptions.deliveryToAddress,
            text: "משלוח",
            component: (
                <DeliveryAddressInput
                    path={`locationFilter.${deliveryAddressOptions.deliveryToAddress}`}
                    deliveryType={deliveryAddressOptions.deliveryToAddress}
                    placeholder="הזן רחוב/ מס׳ בניין/ עיר"
                    showDeliveryPrice={false}
                />
            )
        },
        {
            key: deliveryAddressOptions.selfPickup,
            text: "איסוף עצמי",
            component: (
                <DeliveryAddressInput
                    path={`locationFilter.${deliveryAddressOptions.selfPickup}`}
                    deliveryType={deliveryAddressOptions.selfPickup}
                    placeholder={"הזן עיר"}
                    showDeliveryPrice={false}
                    searchType={GoogleMapSubAreaApiKeys}
                    isSelfPickupPossible={true}
                />
            )
        }
    ];
};
